import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <p>© 2025 vhearu. All rights reserved.</p>
    </footer>
  );
};

export default Footer;